export default "__VITE_ASSET__BMBRlKPQ__"